module.exports = __webpack_public_path__ + "img/cert18.e1a22481.png";